export default __webpack_public_path__ + "static/media/top-banner.4fe290d9.jpg";